import { BaseWebComponentView } from '../../framework/BaseWebComponentView';
import { WEB_COMPONENT_NETWORK_APP_CONTAINER } from '../../webcomponents.constants';
import { NetworkAppContainerWebComponent } from '../../networkV2/networkAppContainer';
import { NetworkDrillDownData } from '../../networkV2/networkAppContainer/helpers/types';
export class NetworkV2AppView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
  }

  buildSuccessView(data: NetworkDrillDownData) {
    this.dom.$wrapper.innerHTML = '';
    const $networkV2Container = document.createElement(
      WEB_COMPONENT_NETWORK_APP_CONTAINER
    ) as NetworkAppContainerWebComponent;

    if (data.externalParams) {
      $networkV2Container.externalParams = data.externalParams;
    }

    $networkV2Container.start().then().catch();
    this.dom.$wrapper.appendChild($networkV2Container);
    $networkV2Container.controller?.view.setLoadingState();
  }
}
